import fetchJson from '../../fetchJson';
import ShopifyApiError from '../ShopifyApiError';
import customErrorHandler from '../customErrorHandler';

const fetchCartJson = async () => {
  return fetchJson({
    url: `${window.Shopify.routes.root}cart.js`,
    options: {
      customErrorHandler,
      bypassErrors: [ShopifyApiError],
    },
  });
};

export default fetchCartJson;
